// extracted by mini-css-extract-plugin
export default {"login-card":"Login_login-card__VZWPe","login-card-wrapper":"Login_login-card-wrapper__7nPhw"};